module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/818cc10dfee980fa11921930747a6cf9.png";